var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.6290323,0 24,5.37096774 24,12 C24,18.6290323 18.6290323,24 12,24 C5.37096774,24 0,18.6290323 0,12 C0,5.37096774 5.37096774,0 12,0 Z M12,4.64516129 C9.648406,4.64516129 7.74193548,6.5516318 7.74193548,8.90322581 C7.74193548,11.2548198 9.648406,13.1612903 12,13.1612903 C14.351594,13.1612903 16.2580645,11.2548198 16.2580645,8.90322581 C16.2580645,6.5516318 14.351594,4.64516129 12,4.64516129 Z M12,21.2903226 C14.840332,21.2903226 17.3854744,20.0032447 19.0887097,17.9903131 C18.1790417,16.2774383 16.398406,15.0967742 14.3225806,15.0967742 C14.2064327,15.0967742 14.090332,15.1161479 13.9790512,15.1499811 C13.3548387,15.3532164 12.691926,15.483871 12,15.483871 C11.308074,15.483871 10.6499811,15.3532164 10.0209488,15.1499811 C9.90966797,15.1161479 9.79356729,15.0967742 9.67741935,15.0967742 C7.601594,15.0967742 5.82095829,16.2774383 4.91129032,17.9903131 C6.61452558,20.0032447 9.15966797,21.2903226 12,21.2903226 Z",
    id: "sign-in",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.959b0c54.svg";
export { ForwardRef as ReactComponent };